import { render, staticRenderFns } from "./SettingsCard.vue?vue&type=template&id=4e0dd116&scoped=true&"
import script from "./SettingsCard.vue?vue&type=script&lang=ts&"
export * from "./SettingsCard.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsCard.vue?vue&type=style&index=0&id=4e0dd116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0dd116",
  null
  
)

export default component.exports